import { render, staticRenderFns } from "./InternalDocumentReasonModal.vue?vue&type=template&id=164950c8"
import script from "./InternalDocumentReasonModal.vue?vue&type=script&lang=js"
export * from "./InternalDocumentReasonModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports